var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":'edit-voucher-' + _vm.voucher_id,"title":"Editar cupón"}},[_c('ContentOrLoading',[(_vm.voucher)?_c('Form',{attrs:{"voucher":_vm.voucher},on:{"terminado":function($event){return _vm.editarVoucher()}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }